export const translation = {
  navigateToPaymentMethods: 'Andere Zahlungsmethode wählen',
  payWithCard: 'Mit Kreditkarte zahlen',
  cardNumber: 'Kartennummer',
  cardExpiry: 'Gültig bis (MM/JJ)',
  cardExpiryPlaceholder: 'MM/JJ',
  cardCVV: 'Prüfnr',
  digits: 'ziffern',
  cardholderName: 'Name des Karteninhabers',
  cardholderNamePlaceholder: 'vollständiger Name',
  previouslyUsed: 'Zuvor verwendet:',
  forgetPaymentMethods: 'Zahlungsmethoden löschen',
  forgetSavedCard: 'Karte mit den letzten Ziffern {{last4Digits}} löschen',
  required: 'Erforderlich',
  invalid: 'Ungültig',
  cardInvalid: 'Kartennummer ungültig',
  expiryInvalid: 'Das Ablaufdatum ist ungültig',
  expiryMonthInvalid: 'Der Ablaufmonat ist ungültig',
  expiryYearInvalid: 'Das Ablaufjahr ist ungültig',
  cardExpired: 'Karte ist abgelaufen',
  cardIncomplete: 'Kartennummer ist unvollständig',
  expiryIncomplete: 'Das Ablaufdatum ist unvollständig',
  cvvIncomplete: 'CVV-Code ist unvollständig',
  cvvInvalid3: 'CVV muss 3-stellig sein',
  cvvInvalid4: 'CVV muss 4-stellig sein',
  cardRequired: 'Kartennummer ist erforderlich',
  expiryRequired: 'Ablaufdatum ist erforderlich',
  cvvRequired: 'CVV-Code ist erforderlich',
  cardNameRequired: 'Name auf Karte ist erforderlich',
  forgetPayPal: 'PayPal-Konto löschen',
  savePaymentMethod: 'Zahlungsmethode speichern',
  managePaymentMethods: 'Verwalten Sie Ihre Zahlungsmethoden',
  savedPaymentMethodsEmpty:
    'Geben Sie unten Ihre Kartendaten ein, um eine neue Zahlungsmethode hinzuzufügen',
  newPaymentMethod: 'Fügen Sie eine neue Zahlungsmethode hinzu',
  cardEndingWith: 'Karte endet mit',
  otherWaysToPay: 'Andere Zahlungsmöglichkeiten',
  pay: 'Zahlen',
  addCard: 'Karte hinzufügen',
  // Payment methods dropdown
  editPaymentMethods: 'Bearbeiten Sie gespeicherte Zahlungsmethoden',
  confirmCardDeletion: 'Bestätigen - Löschen Karte',
  confirmPayPalDeletion: 'Bestätigen - Löschen PayPal',
  delete: 'Löschen',
  cancel: 'Stornieren',
  // Direct Debit Form
  accountHolder: 'Kontoinhaber',
  address: 'Adresse',
  addressLine1: 'Adresse Linie 1',
  addressLine2: 'Adresse Linie 2',
  fullName: 'Vollständiger Name',
  email: 'E-mail',
  city: 'Stadt',
  postalCode: 'Postleitzahl',
  setUpDirectDebit: 'Einrichten Direct Debit',
  unsupportedCardType: 'Nicht unterstützter Kartentyp',
  // Success scene
  checkSuccessTitle: 'Ihre Zahlung war erfolgreich!',
  // Error
  tokenizationError:
    'Ihre Zahlung konnte nicht verarbeitet werden. Bitte versuchen Sie es mit einer anderen Zahlungsmethode.',
  duplicatePaymentMethodError: 'Diese Zahlungsmethode ist bereits gespeichert.',
  // Payment Method Popup Overlay
  paymentMethodPopupOverlayClose: 'Schließen',
  paymentMethodPopupOverlayDescription:
    'Haben Sie Probleme beim Anzeigen der {{paymentMethodName}} Zahlungsseite? Wir helfen Ihnen, es zu finden!',
  paymentMethodPopupOverlayBringBackThePaymentPage: 'Zahlungsseite anzeigen',
};
